/**
 * Phase 1 uiStore — modal state only.
 *
 * - `activeModal` is the source of truth (read via useUiStore in App).
 * - `gameStarted` is mirrored from `gameStore.setGameStarted` for keyboard/modal gates.
 */
import { useSyncExternalStore } from 'react';
import type { ActiveModal } from '../components/UIOverlay';

type UiState = {
  activeModal: ActiveModal;
  gameStarted: boolean;
};

let state: UiState = { activeModal: 'none', gameStarted: false };
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export const uiStore = {
  getState: () => state,
  setActiveModal: (activeModal: ActiveModal) => {
    state = { ...state, activeModal };
    emit();
  },
  /** Phase 1 mirror only — App.tsx owns gameStarted until Wave 6. */
  setGameStarted: (gameStarted: boolean) => {
    state = { ...state, gameStarted };
    emit();
  },
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};

export function useUiStore(): UiState {
  return useSyncExternalStore(uiStore.subscribe, uiStore.getState, uiStore.getState);
}